import { gray3, gray4 } from "assets/styleUtils";
import { useState } from "react";

export default function SelectionItem({
  title,
  isSelected,
  onClick,
}: {
  title: string;
  isSelected: boolean;
  onClick: () => void;
}) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <div
        style={{
          fontSize: "15px",
          fontWeight: "bold",
          color: gray3,
          margin: "10px 0",
        }}
      >
        {title}
      </div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <img
          src={
            isSelected ? "/images/checkCircle.png" : "/images/uncheckCircle.png"
          }
          style={{ width: "18px", height: "18px", cursor: "pointer" }}
          onClick={onClick}
        />
        <div
          style={{
            color: gray4,
            fontSize: "12px",
            fontWeight: "bold",
            margin: "3px 0 0 3px",
            cursor: "pointer",
          }}
        >
          선택
        </div>
      </div>
    </div>
  );
}
